import Policy from './Policy'

// Backend policies resolved in: backend/components/posts/app/presenters/posts/group_presenter.rb
export type PostsGroupVerbTypes = 'addPostsPosts' | 'archivePostsGroup' | 'updatePostsGroup'

class PostsGroupPolicy extends Policy<PostsGroupVerbTypes> {
  checkVerb(verb: PostsGroupVerbTypes): boolean {
    switch (verb) {
      case 'addPostsPosts':
        return this.permissions.add_posts

      case 'updatePostsGroup':
        return this.permissions.update

      case 'archivePostsGroup':
        return this.permissions.archive

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default PostsGroupPolicy
